<template>
  <ca-collapse-table>
    <report-center-table-row
      v-for="(report, index) in reports"
      :key="index"
      :report="report">
    </report-center-table-row>
  </ca-collapse-table>
</template>

<script>
import ReportCenterTableRow from '../report-center-table-row/ReportCenterTableRow.vue';

export default {
  name: 'ReportCenterTable',
  components: {
    ReportCenterTableRow,
  },
  props: {
    reports: {
      type: Array,
      required: true,
    },
  },
};
</script>
